import i18n from '../../i18n';

const chartTimeFrames = [
  { key: 'M1', value: 1, label: 'common.chartTime.m1' },
  { key: 'M5', value: 5, label: 'common.chartTime.m5' },
  { key: 'M15', value: 15, label: 'common.chartTime.m15' },
  { key: 'M30', value: 30, label: 'common.chartTime.m30' },
  { key: 'H1', value: 60, label: 'common.chartTime.h1' },
  { key: 'H4', value: 240, label: 'common.chartTime.h4' },
  { key: 'D1', value: 1440, label: 'common.chartTime.d1' },
  { key: 'W1', value: 10080, label: 'common.chartTime.w1' },
  { key: 'MN', value: 43200, label: 'common.chartTime.mn' },
];

export const TRADING_VIEW_TIME_FRAMES_TO_FXTR = {
  1: 'M1',
  5: 'M5',
  15: 'M15',
  30: 'M30',
  60: 'H1',
  240: 'H4',
  '1D': 'D1',
  '1W': 'W1',
  '1M': 'MN',
};

const chartTypes = [
  { key: 'line', value: 'LINE', label: 'common.charts.line' },
  { key: 'candles', value: 'CANDLES', label: 'common.charts.candles' },
];

const CANDLE_COUNT = 100;

const CHART_TYPES = {
  CANDLES: 'CANDLES',
  LINE: 'LINE',
  LAST: 'LAST',
};

i18n.on('languageChanged', () => {
  chartTimeFrames.forEach((f) => {
    f.label = i18n.t(`common.chartTime.${f.key.toLowerCase()}`);
  });
  chartTypes.forEach((f) => {
    f.label = i18n.t(`common.charts.${f.key.toLowerCase()}`);
  });
});

export { chartTimeFrames, CANDLE_COUNT, CHART_TYPES, chartTypes };
